import { render, staticRenderFns } from "./CityPage.vue?vue&type=template&id=5e36520b&scoped=true&"
import script from "./CityPage.vue?vue&type=script&lang=js&"
export * from "./CityPage.vue?vue&type=script&lang=js&"
import style0 from "./CityPage.vue?vue&type=style&index=0&id=5e36520b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36520b",
  null
  
)

export default component.exports